



























































































import {Component, Vue} from 'vue-property-decorator';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import {Action, Getter} from 'vuex-class';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import PagingControl, { Page } from '@/shared/components/PagingControl.vue';
import Toast from '@/shared/services/toast';
import Check from 'vue-material-design-icons/Check.vue';
import Close from 'vue-material-design-icons/Close.vue';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import ReloadIcon from 'vue-material-design-icons/Reload.vue';
import EditIntentModal from '@/features/bots/components/designer/EditIntentModal.vue';
import AddIntentModal from '@/features/bots/components/designer/AddIntentModal.vue';
import {nlpApi} from '@/features/bots/services/nlp';
import {PredictionViewModel} from '@/features/bots/models/intents/predictionViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import {IntentScoreViewModel} from '@/features/bots/models/intents/intentScoreViewModel';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import {IntentViewModel} from '@/features/bots/models/intents/intentViewModel';
@Component({
	components: {
		DropDownMenu,
		LoadingSpinner,
		PagingControl,
		Check,
		Close,
		EditIcon,
		AddIcon,
		ReloadIcon,
		EditIntentModal,
		AddIntentModal
	}
})
export default class ActiveLearning extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public predictions: PredictionViewModel[] = [];
	public addingUtterance = '';
	public deletingPredictionId = '';
	public loading: boolean = true;
	public total = 0;
	public rowsPerPage = 25;
	public startIndex = 0;

	public intentToEditId = '';

	public async mounted() {
		await this.loadPredictionHistory();
	}

	public getFormattedIntentScore(intentScore: IntentScoreViewModel) {
		return intentScore.score === 0 ? `${intentScore.title} (N/A)` : `${intentScore.title} (${intentScore.score})`;
	}

	public onPageChanged(page: Page) {
		this.startIndex = page.start;
		this.loadPredictionHistory();
	}

	public editIntent(id: string) {
		if (this.isActionInProgress()) {
			return;
		}

		this.intentToEditId = id;
		this.$nextTick(() => {
			const modal: any = this.$refs.editIntentModal;
			if (modal) {
				modal.showModal();
			}
		});
	}

	public async addToIntent(utterance: string, intentId: string) {
		if (this.isActionInProgress()) {
			return;
		}

		try {
			this.addingUtterance = utterance;
			await nlpApi.addUtteranceToIntent(this.currentWorkspace.id, intentId, utterance);
			this.total--;
			this.predictions = this.predictions.filter(p => p.utterance !== utterance);
			Toast.showSuccess(`Added message to intent`);
		} catch (ex) {
			Toast.showError(`Failed to add message to intent: ${ex.message}`);
		} finally {
			this.addingUtterance = '';
		}
	}

	public isActionInProgress() {
		return this.addingUtterance !== '' || this.deletingPredictionId !== '';
	}

	public isUtteranceBeingAdded(utterance: string) {
		return this.addingUtterance === utterance;
	}

	public isPredictionBeingDeleted(utterance: string) {
		return this.deletingPredictionId === utterance;
	}

	public async reloadPredictions() {
		await this.loadPredictions();
		Toast.showSuccess(`Latest predictions loaded`);
	}

	public reloadPageMessage() {
		return 'Refresh page';
	}

	public async deletePrediction(predictionId: string) {
		if (this.isActionInProgress()) {
			return;
		}
		try {
			this.deletingPredictionId = predictionId;
			await nlpApi.deletePrediction(this.currentWorkspace.id, predictionId);
			this.total--;
			this.predictions = this.predictions.filter(p => p.id !== predictionId);
			Toast.showSuccess('Successfully removed message');
		} catch (err) {
			Toast.showError(`Failed to remove message: ${err.message}`);
		} finally {
			this.deletingPredictionId = '';
		}
	}

	public addNewIntent(utterance: string) {
		const modal: any = this.$refs.addIntentModal;
		if (modal) {
			modal.addNewIntent(utterance);
		}

		this.$emit('modal-opened');
	}

	public addedIntent(intent: IntentViewModel) {
		const utterances = intent.utterances.map(u => u.text.toLowerCase());
		const noPredictionsBefore = this.predictions.length;
		this.predictions = this.predictions.filter(p => !utterances.includes(p.utterance.toLowerCase()));
		this.total -= noPredictionsBefore - this.predictions.length;
	}


	private async loadPredictionHistory() {
		this.loading = true;
		await this.loadPredictions();
		this.loading = false;
	}

	private async loadPredictions() {
		const pagedResults = await nlpApi.getPredictions(this.currentWorkspace.id, this.rowsPerPage, this.startIndex);
		this.total = pagedResults.total;
		this.predictions = pagedResults.page;
		this.predictions.forEach(prediction => {
			prediction.selectedIntent = prediction.intentScores[0];
		});
	}
}

